import React from "react";
import PropTypes from "prop-types";

const FormRadioEntry = ({ label = "", name = "", options = [], defaultValue = "", saveChanges = f => f }) => (
    <div className="formRadio w3-animate-opacity">
        <label className="formText w3-text-blue w3-bold w3-animate-opacity">
            <b>{label}</b>
        </label>
        <div className="radioEntry w3-input">
            {options.map((option, i) => {
                const parts = option.split(',');
                const text = parts[0];
                const value = parts.length === 2 ? parts[1] : parts[0];
                if (value === defaultValue) {
                    return (
                        <div key={i}>
                            <input
                                className="w3-radio w3-padding-small"
                                type="radio"
                                id={text}
                                key={text}
                                name={name}
                                value={value}
                                checked
                                onChange={evt => saveChanges(name, evt.target.value)}
                            />
                            &nbsp;<label>{text}</label>
                        </div>
                    );
                } else {
                    return (
                        <div key={i}>
                            <input
                                className="w3-radio w3-padding-small"
                                type="radio"
                                id={text}
                                key={text}
                                name={name}
                                value={value}
                                onChange={evt => saveChanges(name, evt.target.value)}
                            />
                            &nbsp;<label>{text}</label>
                        </div>
                    );
                }
            })}
        </div>
    </div>
);

FormRadioEntry.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array,
    saveChanges: PropTypes.func
};

export default FormRadioEntry;
